import { defineStore } from 'pinia';
import * as constants from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const useAppStore = defineStore('app', {
    id: 'app',

    state: () => ({
        // Widget configuration options.
        options: {},

        // Is the widget busy doing something that blocks the entire UI.
        isBusy: true,
        isQuietBusy: false,

        currentStep: constants.STEP_LOADING,

        isLoading: false,

        selfDestruct: false,

        isMobile: false,

        isKeyboardOpen: false,
    }),

    actions: {
        /**
         * Save options.
         */
        setOptions(options) {
            this.options = options;
        },

        /**
         * Sets whether customizer is doing something that takes a long time.
         */
        setIsBusy(isBusy) {
            this.isBusy = isBusy;
        },

        /**
         * Close the widget.
         */
        globalDone() {
            this.selfDestruct = true;
        },

        /**
         * Close the widget without making changes.
         */
        globalCancel() {
            if (this.options.onCancel) {
                this.options.onCancel();
            }

            this.selfDestruct = true;
        },

        /**
         * Sets current application step.
         */
        setCurrentStep(step) {
            this.currentStep = step;
        },

        /**
         * Sets whether the viewport is mobile size.
         */
        setIsMobile(isMobile) {
            this.isMobile = isMobile;
        },

        /**
         * Sets whether the keyboard is open on mobile. Used when inputs gain and lose focus.
         */
        toggleKeyboard(isOpen) {
            this.isKeyboardOpen = isOpen;

            if (!isOpen) {
                setTimeout(() => {
                    document.documentElement.scrollTop = 0;
                });
            }
        },
    },
});
